import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { hubEvents } from "@/lib/api";
import { track } from "@/lib/analytics";
import { Calendar, Check, ArrowRight } from "lucide-react";

export default function HubEvents() {
  const navigate = useNavigate();
  const { data = [], isLoading } = useQuery({ queryKey: ["hub-events"], queryFn: hubEvents });
  return (
    <div data-testid="hub-events">
      <p className="cv-kicker">Events</p>
      <h1 className="cv-display text-3xl mt-4">Your member calendar.</h1>
      {isLoading ? (
        <p className="cv-body text-[#9A938A] mt-8">Loading...</p>
      ) : (
        <div className="mt-8 space-y-3">
          {data.map((e) => (
            <div key={e.slug} data-testid="hub-event-item" className="border border-[rgba(28,27,25,0.14)] rounded-[14px] p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <span className="cv-kicker">{e.kind}</span>
                <h3 className="cv-h2 text-base mt-2">{e.title}</h3>
                <p className="cv-body text-xs text-[#9A938A] mt-1 flex items-center gap-2"><Calendar size={13} /> {e.event_date} · {e.format}</p>
              </div>
              {e.registered ? (
                <span className="cv-sans uppercase tracking-[0.12em] text-[0.68rem] text-[#515E4F] inline-flex items-center gap-2"><Check size={14} /> Registered</span>
              ) : (
                <button data-testid="hub-event-register" className="cv-btn-secondary inline-flex items-center gap-2" onClick={() => { track("door_click", { target: "event_register", event: e.slug, location: "hub" }); navigate(`/events/${e.slug}`); }}>
                  {e.price_label} · View and register <ArrowRight size={14} />
                </button>
              )}
            </div>
          ))}
          {data.length === 0 && <p className="cv-body text-sm text-[#9A938A]">No open events right now.</p>}
        </div>
      )}
    </div>
  );
}
